import { Ref, useCallback, useImperativeHandle } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import AddLocation from "../../../AddLocation/AddLocation";

export type AddLocationCreatorFragmentConfigProps = {
  field: string;
};

type AddLocationCreatorFragmentProps = {
  configProps: AddLocationCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AddLocationCreatorFragment({
  configProps,
  commonProps,
  ref,
}: AddLocationCreatorFragmentProps) {
  const { field } = configProps;
  const { blockInput, task, onTaskChange, showValidation } = commonProps;
  const slid = getByPath<string>(task, field);
  const itemNo = "70466811";
  // itemNo will be hardcoded until we have itemNo in task details
  //   const itemNo = getByPath<string>(task, "itemNo");

  const handleConfirmClick = useCallback(
    (newSlid: string) => {
      onTaskChange(setByPath(field, newSlid));
    },
    [field, onTaskChange]
  );

  const valid = !isLoading(slid) && !!slid;

  useImperativeHandle(ref, () => {
    return { valid };
  });

  if (isLoading(slid)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <AddLocation
      slid={slid}
      itemNo={itemNo}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput}
      isError={!slid && showValidation}
    />
  );
}

export default AddLocationCreatorFragment;
